<template>
  <el-tooltip :visible="visible" effect="dark" :content="text" :placement="placement" :disabled="disabled" popper-class="comTip_popper">
    <template #content>
      <slot name="content"></slot>
    </template>
    <div :class="[props.column==1?'WS_nowrap':'WS_normal',textClass]" :style="textStyle" @mouseenter="handleMouseOver" @mouseleave="handleMouseOut" @click="handle(text)">
      <slot name="textBefore"></slot>
      <span class="comTip_text" :style="contentStyle">{{ifNull(text) ? text : defaultText}}</span>
    </div>
  </el-tooltip>
</template>


<script setup>
import { ref } from "vue";
import { ifNull } from "./utils/index";
const emit = defineEmits(["handle"]);
const props = defineProps({
  text: {
    type: String,
    default: "",
  },
  defaultText: {
    type: String, //当text的内容为空时，设置的默认内容
    default: "-",
  },
  textStyle: {
    type: [String, Object],
    default: "",
  },
  contentStyle: {
    type: [String, Object],
    default: "",
  },
  placement: {
    type: String,
    default: "top-start", //'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end' | 'right' | 'right-start' | 'right-end'
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  textClass: {
    type: String,
    default: "",
  },
  column: {
    type: String, //第几行开始隐藏
    default: 1,
  },
});

let visible = ref(false);
const handleMouseOver = (e) => {
  const ev = e.target;
  if (props.column == 1) {
    if (ev.scrollWidth > ev.clientWidth) {
      visible.value = true;
    } else {
      visible.value = false;
    }
  } else {
    if (ev.scrollHeight > ev.clientHeight) {
      visible.value = true;
    } else {
      visible.value = false;
    }
  }
};
const handleMouseOut = (e) => {
  const popperNode = document.querySelector(".comTip_popper");
  let timer = null;
  timer = setTimeout(() => {
    visible.value = false;
  }, 200);
  if (popperNode) {
    popperNode.onmouseenter = () => {
      clearTimeout(timer);
    };
    popperNode.onmouseleave = () => {
      visible.value = false;
    };
  }
};
const handle = (text) => {
  emit("handle", text);
};
</script>
<style scoped lang="less">
.WS_normal {
  width: 100%;
  min-width: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: v-bind(column);
  text-overflow: ellipsis;
  font-size: var(--fontSize14);
  color: #333;
  white-space: normal;
}
.WS_nowrap {
  width: 100%;
  min-width: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: var(--fontSize14);
  color: #333;
  white-space: nowrap;
}
.comTip_text {
  font-size: inherit;
  color: inherit;
  overflow-wrap: break-word;
}
</style>